// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2EB82","name":"ConsentHeader_name__3s5Hp","birthday":"ConsentHeader_birthday__30Gpq","skeleton":"ConsentHeader_skeleton__3UKll"};